import { useLayoutEffect, useRef, useState } from "react";

import { useResizeObserver } from "../../hooks.ts";
import { truncateByOverflow } from "../../utils/string/truncate-middle.ts";

interface TruncateTextProps {
  text: string;
  ellipsis?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function TruncateText({
  text,
  ellipsis = "…",
  className = "",
  style,
  ...props
}: TruncateTextProps & React.HTMLAttributes<HTMLSpanElement>) {
  const elementRef = useRef<HTMLSpanElement>(null);
  const [displayText, setDisplayText] = useState(text);
  const box = useResizeObserver(elementRef);

  useLayoutEffect(() => {
    if (elementRef.current) {
      const result = truncateByOverflow(elementRef.current, text, ellipsis);
      setDisplayText(result);
    }
  }, [text, ellipsis, box?.width]);

  const defaultStyle: React.CSSProperties = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "unset",
    wordBreak: "unset",
    ...style,
  };

  return (
    <span
      ref={elementRef}
      className={className}
      style={defaultStyle}
      title={displayText !== text ? text : undefined}
      {...props}
    >
      {displayText}
    </span>
  );
}
